export default __webpack_public_path__ + "static/media/main-admin.c75541c8.svg";